import * as React from 'react'
import { FormattedMessage } from 'react-intl'

import styles from './dooer-live.module.scss'

import SubTitle from '../../components/sub-title'

interface IDooerLiveProps {
  inverted?: boolean
  disabled?: boolean
}
const DooerLive = ({ inverted, disabled = true }: IDooerLiveProps) => {
  return disabled ? null : (
    <div className={`${styles.root} ${inverted ? styles.inverted : ''}`}>
      <div className={styles.circle}>
        <FormattedMessage defaultMessage="Dooer live" id="component.dooer-live.title" />
      </div>

      <div className={`row ${styles.container}`}>
        <div className="col-xs-12 col-md-6">
          <SubTitle className={styles.sectionTitle} color="brand">
            <FormattedMessage defaultMessage="Uppladdade verifikat i dooer" id="component.dooer-live.stats-voucher" />
          </SubTitle>
          <div className={styles.section}>{'113.323'}</div>
        </div>
        <div className="col-xs-12 col-sm-6 col-md-3">
          <SubTitle className={styles.sectionTitle} color="brand">
            <FormattedMessage defaultMessage="Bankid-signeringar/minut" id="component.dooer-live.stats-bankid" />
          </SubTitle>
          <div className={styles.section}>{'531'}</div>
        </div>
        <div className="col-xs-12 col-sm-6 col-md-3">
          <SubTitle className={styles.sectionTitle} color="brand">
            <FormattedMessage defaultMessage="Just nu hos ekonomerna" id="component.dooer-live.stats-accounting" />
          </SubTitle>
          <div className={styles.section}>{'n/a'}</div>
        </div>
      </div>
    </div>
  )
}

export default DooerLive
